module.exports = __webpack_public_path__ + "nc_static/media/file-text.b8bee184.svg";